<div class="wrapper-modal">
  <form [formGroup]="editBusinessUserForm" (ngSubmit)="submitEditBusinessUserForm()" class="wrapper-content-modal">
    <div class="header-modal edit-business">
      <span class="title-modal">Izmeni biznis korisnika</span>
      <div class="wrapper-approve">
        <span *ngIf="businessUserForEdit.email_verified_at !== null" class="label-approved">Odobreno</span>
        <button *ngIf="businessUserForEdit.email_verified_at === null" (click)="approveUser()" type="button" class="zc-btn zc-btn--primary"><span>Odobri</span></button>
      </div>
    </div>
    <div class="content-modal">
      <div class="wrapper-input">
        <span class="label-input">Ime</span>
        <div class="zc-input">
          <input type="text" [formControl]="editBusinessUserForm.controls.first_name | formControl" [placeholder]="'Ime'">
        </div>
        <span class="error-message">{{editBusinessUserForm.controls.first_name | formControlErrorMessages: null : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">Prezime</span>
        <div class="zc-input">
          <input type="text" [formControl]="editBusinessUserForm.controls.last_name | formControl" [placeholder]="'Prezime'">
        </div>
        <span class="error-message">{{editBusinessUserForm.controls.last_name | formControlErrorMessages: null : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">E-pošta</span>
        <div class="zc-input">
          <input type="text" [formControl]="editBusinessUserForm.controls.email | formControl" [placeholder]="'E-pošta'">
        </div>
        <span class="error-message">{{editBusinessUserForm.controls.email | formControlErrorMessages: 'Unesite validnu E-poštu.' : formTriedToSubmit}}</span>
      </div>
      <div class="wrapper-input">
        <span class="label-input">Telefon</span>
        <div class="zc-input">
          <input type="text" [formControl]="editBusinessUserForm.controls.phone | formControl" [placeholder]="'Telefon'">
        </div>
        <span class="error-message">{{editBusinessUserForm.controls.phone | formControlErrorMessages: 'Unesite validan broj telefona.' : formTriedToSubmit}}</span>
      </div>
    </div>
    <div class="footer-modal">
      <button type="button" (click)="closeModal.emit()" class="zc-btn zc-btn--gray"><span>Izađi</span></button>
      <button type="submit" class="zc-btn zc-btn--primary"><span>Izmeni</span></button>
    </div>
  </form>
</div>

